import { PriceWrapper } from "@/app/price"
import { Trans } from "@lingui/react/macro"
import { reatomComponent } from "@reatom/react"
import { useSuspenseQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { ChangeTrend } from "../leaderboard/view/change-trend"
import { CollectionMoleculeReatom } from "../store/index.reatom"
import { TrendDisplay } from "./trend-display"

export function EssentialCollectionStatistic() {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <StatisticContent />
      </Suspense>
    </ErrorBoundary>
  )
}

const StatisticContent = reatomComponent(() => {
  const { statisticQueryParamsAtom } = useMolecule(CollectionMoleculeReatom)
  const queryParams = statisticQueryParamsAtom()
  const { data: statistic } = useSuspenseQuery(queryParams)

  return (
    <div className="hidden items-center gap-x-6 lg:flex">
      {statistic.floor && (
        <StatisticItem
          title={<Trans>Floor Price</Trans>}
          content={<PriceWrapper {...statistic.floor} />}
        />
      )}
      {statistic.dayFloorChange ? (
        <StatisticItem
          title={<Trans>Fl. ch 24h</Trans>}
          content={
            <ChangeTrend
              className="gap-0"
              changePercent={statistic.dayFloorChange}
              TrendDisplay={TrendDisplay}
            />
          }
        />
      ) : null}
      {statistic.topOffer && (
        <StatisticItem
          title={<Trans>Top Offer</Trans>}
          content={<PriceWrapper {...statistic.topOffer} />}
        />
      )}
    </div>
  )
}, "StatisticContent")

function StatisticItem({
  title,
  content,
}: {
  title: React.ReactNode
  content: React.ReactNode
}) {
  return (
    <div className="flex items-center gap-x-2">
      <span className="text-foreground/60">{title}</span>
      {content}
    </div>
  )
}
